import { useMutation, useQueryClient } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { ICloseEvaluationResponseData } from '../../../types';

import { EVALUATION_IMAGE_CONFIG_KEY } from './useEvaluationImageConfigQuery';
import { EVALUATIONS_LIST_KEY } from './useEvaluationsListQuery';

/**
 * This is to track the scan package for closing evaluation mutation keys in
 * react query cache.
 */
const CLOSE_EVALUATION_MUTATION_KEY = 'close-evaluation-mutation-key';

interface IUseCloseEvaluationMutationProps {
  onSuccessCallback: (data: ICloseEvaluationResponseData) => void;
}

/**
 * React Query mutation function for closing an evaluation.
 */
export const useCloseEvaluationMutation = ({
  onSuccessCallback,
}: IUseCloseEvaluationMutationProps) => {
  const queryClient = useQueryClient();

  const {
    data,
    error,
    isError,
    isPending,
    mutate: closeEvaluation,
    reset: resetCloseEvaluation,
  } = useMutation({
    mutationKey: [CLOSE_EVALUATION_MUTATION_KEY],
    networkMode: 'always',
    mutationFn: INBOUND_API.closeEvaluation,
    onSuccess: (data) => {
      // Invalidate the query cache for the evaluation list to ensure it is
      // refreshed after closing an evaluation.
      queryClient.invalidateQueries({
        queryKey: [EVALUATIONS_LIST_KEY, EVALUATION_IMAGE_CONFIG_KEY],
      });

      if (onSuccessCallback) {
        onSuccessCallback(data);
      }
    },
  });

  return {
    closeEvaluation,
    data,
    error,
    isError,
    isPending,
    resetCloseEvaluation,
  };
};
